import Head from 'next/head';
import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();
import {
  googleAnalyticsPropertyId,
  googleTagManagerApiKey,
  sentryDnsKey,
  facebookPixelId,
} from '../../constants';

const Scripts = ({ abTestForGA }) => (
  <Head>
    {/* Google Analytics */}
    <style>{`
      .async-hide {
        opacity: 0 !important;
      }
    `}</style>
    <script
      dangerouslySetInnerHTML={{
        __html: `
    (function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;
    h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
    (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
  })(window,document.documentElement,'async-hide','dataLayer',4000,
    {'GTM-W73GNWN':true});`,
      }}
    />
    {publicRuntimeConfig.isProd
      ? [
          <script
            key={'ga-prod-lib'}
            async
            dangerouslySetInnerHTML={{
              __html: `
              window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;
              ga('create', '${googleAnalyticsPropertyId}', 'auto');
              ga('set', 'dimension7', 'ab_test: ${abTestForGA}');
              ga('require', 'GTM-W73GNWN');`,
            }}
          />,
          <script
            defer
            key={'ga-prod-analytics'}
            src="https://www.google-analytics.com/analytics.js"
          />,
          <script
            key={'ga-prod-random'}
            dangerouslySetInnerHTML={{
              __html: `ga('require', 'ecommerce');`,
            }}
          />,
        ]
      : [
          <script
            key={'ga-dev-lib'}
            dangerouslySetInnerHTML={{
              __html: `
            (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
      ga('create', 'UA-23349176-1', 'auto');
      ga('require', 'GTM-W73GNWN');
      ga('set', 'dimension7', 'ab_test: ${abTestForGA}');
      ga('send', 'pageview');`,
            }}
          />,
          <script
            key={'ga-dev-random'}
            async
            dangerouslySetInnerHTML={{
              __html: `ga('require', 'ecommerce');`,
            }}
          />,
        ]}

    {/* Sentry - only add if it's production */}
    {publicRuntimeConfig.isProd
      ? [
          <script
            key={'sentry-prod'}
            src="//browser.sentry-cdn.com/5.5.0/bundle.min.js"
          />,
          <script
            key={'sentry-dev'}
            dangerouslySetInnerHTML={{
              __html: `Sentry.init({
              dsn: '${sentryDnsKey}',
              environment: '${process.env.NODE_ENV}',
              ignoreErrors: [
                /OpenYoloError.*/,
                'The prompt() method must be called with a user gesture'
              ]
            });`,
            }}
          />,
        ]
      : null}
    {/* google tag manager */}
    <script
      async
      dangerouslySetInnerHTML={{
        __html: `(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', '${googleTagManagerApiKey}');`,
      }}
    />
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-WH65K8X"
        height="0"
        width="0"
        style={{ visibility: 'hidden', display: 'none' }}
      ></iframe>
    </noscript>
    {/* facebook pixel */}
    <script
      async
      dangerouslySetInnerHTML={{
        __html: `
          if (typeof fbq === 'undefined') {
            !function(f,b,e,v,n,t,s) {if(f.fbq)return;n=f.fbq=function(){n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)}; if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0'; n.queue=[];t=b.createElement(e);t.async=!0; t.src=v;s=b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s)}(window,document,'script', 'https://connect.facebook.net/en_US/fbevents.js'); fbq('init', '${facebookPixelId}');
          } else {
            fbq('init', '${facebookPixelId}');
          }
        `,
      }}
    />
    {/* one tap login  */}
    <script async src="https://accounts.google.com/gsi/client"></script>
    {/* <script async src="https://smartlock.google.com/client" /> */}

    <noscript>
      <img
        height="1"
        width="1"
        src={`https://www.facebook.com/tr?id=${facebookPixelId}&ev=PageView&noscript=1`}
      />
    </noscript>
  </Head>
);

export default Scripts;



// WEBPACK FOOTER //
// ./components/header/scripts.tsx